import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from "../";
import { IBaseResponse, IMicrositeRecipientCoachLogEntry, IMicrositeRecipientCommunication } from '@nkr/models/index';
import { IPost } from '../authorization';
import { IDelete } from '../authorization/actions';

export interface ICommunicationResponse {
    data: {
        success: boolean,
        message: string,
        results: IMicrositeRecipientCommunication[]
    }
}

export interface ICoachLogEntryResponse {
    data: {
        success: boolean,
        message: string,
        results: IMicrositeRecipientCoachLogEntry
    }
}

export interface IChangeCoachStatusRequest {
    
    newCoachStatus: number,
    transplantDate: string,
    nextFollowupDate: string,
    mostRecentContactDate: string,
    isCoachingDesired: boolean
}


export const ActionCreators = {
    sendNote: (micrositeRecipientId: number, note: string) => async (dispatch: Dispatch<IApplicationState>): Promise<ICommunicationResponse> => {
        var options: IPost = {
            url: `${__API__}/microsite/coach/send-note`,
            data: {
                micrositeRecipientId,
                note,
                sentByRecipient: false
            }
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    replyToNote: (noteId: number, reply: string) => async (dispatch: Dispatch<IApplicationState>): Promise<ICommunicationResponse> => {
        var options: IPost = {
            url: `${__API__}/microsite/coach/reply-to-note`,
            data: {
                noteId,
                reply
            }
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    markViewed: (micrositeRecipientId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options: IPost = {
            url: `${__API__}/microsite/coach/note-viewed/${micrositeRecipientId}`,
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    saveCoachLogEntry: (id: number, micrositeRecipientId: number, content: string, actionType: number, isPinned: boolean) => async (dispatch: Dispatch<IApplicationState>): Promise<ICoachLogEntryResponse> => {
        var options: IPost = {
            url: `${__API__}/microsite/coach/log-entry`,
            data: {
                id,
                micrositeRecipientId,
                content,
                actionType,
                isPinned
            }
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    deleteCoachLogEntry: (id: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options: IDelete = {
            url: `${__API__}/microsite/coach/log-entry/${id}`
        };

        try {
            return await dispatch(AuthActionCreators.apiDelete(options));
        } catch (error) {
            throw error;
        }
    },

    setNextFollowupDate: (id: number, date: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options: IPost = {
            url: `${__API__}/microsite/${id}/set-follow-up-date?newDate=${date}`
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    setMostRecentContactDate: (id: number, date: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options: IPost = {
            url: `${__API__}/microsite/${id}/set-most-recent-contact-date?newDate=${date}`
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    saveMicrositeByCoach: (formData: FormData) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: `${__API__}/microsite/save`,
            data: formData
        };

        try {
            return await dispatch(AuthActionCreators.apiPostFormData(options));
        } catch (error) {
            throw error;
        }
    },
    changeCoachStatus: (micrositeId: number, request: IChangeCoachStatusRequest) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        const options = {
            url: `${__API__}/microsite/${micrositeId}/change-coach-status`,
            data: request
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    changeCoachOptOutStatus: (id: number, optOutStatus: boolean)=> async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options: IPost = {
            url: `${__API__}/microsite/${id}/coach-opt-out-status/${optOutStatus}`
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
}